import { useRef } from 'react';

import { selectTextContent } from '../utils';

export const useShareLinkCopy = () => {
    const textRef = useRef<HTMLDivElement>(null);
    const buttonRef = useRef<HTMLButtonElement>(null);

    const onCodeClick = () => {
        const selection = window.getSelection()!;

        if (selection.anchorOffset !== selection.focusOffset || selection.anchorNode !== selection.focusNode) {
            return;
        }

        selectTextContent(textRef.current!);
    };

    const onButtonClick = () => {
        selectTextContent(textRef.current!);
        document.execCommand('copy');
    };

    return { onCodeClick, onButtonClick, textRef, buttonRef };
};
